import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";

import { updateLocationState } from "../actions/map";

import MyMapBoxLayer from "../components/MyMapBoxLayer";
import * as StopLayer from "../layers/stops";

const LocationsContainer = (props) => {
  const [locations, setLocations] = useState(props.locations);
  const c = props.currentLocation;

  useEffect(() => {
    setLocations(
      props.locations.filter((l) => props.fleetIds.includes(l.vehicleId))
    );
  }, [props.locations, props.fleetIds]);

  useEffect(() => {
    props.setCenter(locations.filter((l) => !!l.lat)[0]);
  }, [locations]);

  const openPopup = (marker) => {
    props.updateLocationState(marker);
  };

  return (
    <>
      <MyMapBoxLayer
        layer={StopLayer}
        type="pickup"
        markers={_.filter(
          locations,
          (l) =>
            !["dropoff", "end"].includes(l.vType) &&
            l.location_id !== c?.location_id
        )}
        onClick={openPopup}
      />
      <MyMapBoxLayer
        layer={StopLayer}
        type="dropoff"
        markers={_.filter(
          locations,
          (l) =>
            ["dropoff", "end"].includes(l.vType) &&
            l.location_id !== c?.location_id
        )}
        onClick={openPopup}
      />
      {c && (
        <MyMapBoxLayer
          layer={StopLayer}
          type={
            ["dropoff", "end"].includes(c.vType)
              ? "current-dropoff"
              : "current-pickup"
          }
          markers={[c]}
          onClick={openPopup}
        />
      )}
    </>
  );
};

LocationsContainer.propTypes = {
  fleetIds: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  setCenter: PropTypes.func.isRequired,
  updateLocationState: PropTypes.func.isRequired,
  currentLocation: PropTypes.object,
};

export default connect(null, { updateLocationState })(LocationsContainer);
